import React, { useRef, useState } from 'react';
import { useMediaQuery } from '@uidotdev/usehooks';
import { SideBar } from './sideBar';
import { cn } from "../utils/cn";
import { Header } from "./Header";
import { Outlet } from 'react-router-dom';

const Layout = () => {
  const isDesktopDevice = useMediaQuery("(min-width:768px)");
  const [collapsed, setCollapsed] = useState(false);
  const sidebarRef = useRef(null);

  return (
    <div className="bg-[#0a0a0a] transition-colors min-h-screen">
      {/* Overlay for mobile sidebar */}
      <div
        className={cn(
          "pointer-events-none fixed inset-0 -z-10 bg-black opacity-0 transition-opacity",
          !collapsed && "max-md:pointer-events-auto max-md:opacity-30 max-md:z-50"
        )}
        onClick={() => setCollapsed(true)}
      />
      
      {/* Sidebar */}
      <SideBar ref={sidebarRef} collapsed={collapsed} />
      
      {/* Main Content Area */}
      <div
        className={cn(
          "transition-[margin] duration-300",
          collapsed ? "md:ml-[70px]" : "md:ml-[240px]"
        )}
      >
        {/* Header */}
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        
        {/* Content */}
        <div className="h-[calc(100vh-60px)] overflow-y-auto overflow-x-hidden p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;